import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const AIDA = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12707"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12707)">
          <rect
            x="-33.4546"
            y="-2"
            width="197.706"
            height="114"
            rx="6.37762"
            fill="#F4F4F4"
          />
          <rect
            x="31.7168"
            y="21.7166"
            width="49.028"
            height="66.4525"
            rx="3.502"
            fill="white"
            stroke="#191919"
            strokeWidth="1.1958"
          />
          <path
            d="M77.3068 22.1437L32.1438 84.4622C32.1438 84.4622 32.461 86.1663 33.0257 86.7814C33.5903 87.3965 34.3561 87.7421 35.1547 87.7421H77.3068C78.1053 87.7421 78.8711 87.3965 79.4358 86.7814C80.0004 86.1663 80.3176 85.3321 80.3176 84.4622V25.4236C80.3176 24.5537 80.0004 23.7194 79.4358 23.1043C78.8711 22.4892 77.3068 22.1437 77.3068 22.1437Z"
            fill="#E3E3E3"
          />
          <path
            d="M42.3938 36.4933H62.8149"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 42.6432H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 48.7931H62.8149"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 54.9427H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 61.0927H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 67.2426H68.6495"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.3938 73.3928H62.8149"
            stroke="#191919"
            strokeWidth="1.53746"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="31.7168"
            y="21.7166"
            width="49.028"
            height="66.4525"
            rx="3.502"
            stroke="#191919"
            strokeWidth="1.1958"
          />
          <path
            d="M97.6088 57.4826L95.6912 59.4002L89.2993 53.0083L91.2169 51.0907C92.0691 50.2657 93.2115 49.8088 94.3976 49.8184C95.5838 49.828 96.7186 50.3035 97.5573 51.1422C98.3961 51.981 98.8715 53.1158 98.8811 54.3019C98.8908 55.488 98.4338 56.6304 97.6088 57.4826Z"
            fill="#FF808C"
          />
          <path
            d="M82.3193 72.7719L73.3706 75.3287L75.9274 66.38L82.3193 72.7719Z"
            fill="#FFBC44"
          />
          <path
            d="M89.2991 53.0109L75.9272 66.3828L82.3191 72.7747L95.691 59.4028L89.2991 53.0109Z"
            fill="#FFEF5E"
          />
          <path
            d="M97.6088 57.4826L95.6912 59.4002L89.2993 53.0083L91.2169 51.0907C92.0691 50.2657 93.2115 49.8088 94.3976 49.8184C95.5838 49.828 96.7186 50.3035 97.5573 51.1422C98.3961 51.981 98.8715 53.1158 98.8811 54.3019C98.8908 55.488 98.4338 56.6304 97.6088 57.4826Z"
            stroke="#191919"
            strokeWidth="1.1958"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M82.3193 72.7719L73.3706 75.3287L75.9274 66.38L82.3193 72.7719Z"
            stroke="#191919"
            strokeWidth="1.1958"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M89.2991 53.0109L75.9272 66.3828L82.3191 72.7747L95.691 59.4028L89.2991 53.0109Z"
            stroke="#191919"
            strokeWidth="1.1958"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.9814 8.30028L84.7833 14.9999H83.0127L86.0156 6.91816H87.1424L86.9814 8.30028ZM88.8076 14.9999L86.604 8.30028L86.4263 6.91816H87.5642L90.5838 14.9999H88.8076ZM88.7077 11.9915V13.2959H84.4392V11.9915H88.7077ZM93.1038 6.91816V14.9999H91.4442V6.91816H93.1038ZM97.1447 14.9999H95.3851L95.3962 13.7011H97.1447C97.5813 13.7011 97.9495 13.603 98.2493 13.4069C98.549 13.2071 98.7747 12.9166 98.9265 12.5354C99.0819 12.1543 99.1596 11.6936 99.1596 11.1533V10.7592C99.1596 10.3448 99.1152 9.98028 99.0264 9.66574C98.9413 9.3512 98.8136 9.08662 98.6434 8.87199C98.4732 8.65737 98.2641 8.4964 98.0161 8.38909C97.7682 8.27807 97.4833 8.22257 97.1613 8.22257H95.3518V6.91816H97.1613C97.7016 6.91816 98.1956 7.01067 98.6434 7.19569C99.0948 7.37701 99.4852 7.63789 99.8146 7.97834C100.144 8.31878 100.397 8.72583 100.575 9.19948C100.756 9.66944 100.847 10.1931 100.847 10.7703V11.1533C100.847 11.7269 100.756 12.2505 100.575 12.7242C100.397 13.1978 100.144 13.6049 99.8146 13.9453C99.4889 14.2821 99.0985 14.5429 98.6434 14.728C98.1919 14.9093 97.6924 14.9999 97.1447 14.9999ZM96.3287 6.91816V14.9999H94.6635V6.91816H96.3287ZM105.221 8.30028L103.023 14.9999H101.252L104.255 6.91816H105.382L105.221 8.30028ZM107.047 14.9999L104.843 8.30028L104.666 6.91816H105.804L108.823 14.9999H107.047ZM106.947 11.9915V13.2959H102.679V11.9915H106.947Z"
            fill="#626266"
          />
        </g>
      </SvgIcon>
    );
  })
);
